export const cabsLandingerrorMessage = {
  EMPTY_LOCATION_ERROR_MESSAGE: 'Please enter all locations',
  FROM_TO_DIFFERENT_ERROR_MESSAGE:
    'From and To location should not be the same for One Way trips. Please select a round trip',
  WITH_IN_SAME_CITY_ERROR_MESSAGE: 'Please enter location within same city',
  SAME_LOCATIONS_ERROR_MESSAGE:
    'Looks like 2 or more locations are same. Please check!',
  PICKUP_ADDRESS_NOT_SPECIFIC_ERROR_MESSAGE: '',
  DROP_ADDRESS_NOT_SPECIFIC_ERROR_MESSAGE: '',
  PICKUP_ADDRESS_AIRPORT_ERROR_MESSAGE: 'Pickup address must be airport',
  DROP_ADDRESS_AIRPORT_ERROR_MESSAGE: 'Drop address must be airport'
};
